import { useState } from 'react';
import styled, { css } from 'styled-components';

import {
  IconButton,
  IconLinkButton,
  ProcessingTooltip,
  Tooltip
} from '../atoms';

type TProcessedMsg = string | null;

const LinksContainer = styled.div`
  display: grid;
  grid-gap: 30px;
`;

const LinkWrapper = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.white};
  `
);

const Link = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-gap: 30px;
    grid-template-columns: auto 7rem;
    align-items: center;
    padding: 30px 30px 30px;
    border-bottom: 1px solid ${theme.colors.warmGrey};
    transition: 0.35s ease;

    @media (hover: hover) {
      &:hover {
        background-color: ${theme.colors.main.light};
      }
    }
  `
);

const LinkHeading = styled.h2`
  margin-bottom: 0;
`;

const LinkButtons = styled.div(
  ({ theme }) => css`
    position: relative;
    display: grid;
    grid-gap: 4px;
    grid-template-columns: auto 7rem;
    align-items: center;
    padding: 0;
    transition: 0.35s ease;

    @media (hover: hover) {
      &:hover {
        background-color: ${theme.colors.main.light};
      }
    }
  `
);

const LinkButton = styled.div(
  ({ theme }) => css`
    margin: 0;
  `
);

const ButtonWrapper = styled.span`
  @media (hover: hover) {
    &:hover {
      & + span {
        opacity: 1;
        visibility: visible;
      }
    }
  }
`;

type TMerchantLinksList = {
  refreshPage: () => void;
};

const OpenLinkButton = ({ href }) => (
  <LinkButton>
    <ButtonWrapper>
      <IconLinkButton
        iconType="Apply"
        size="2.5rem"
        target="_blank"
        href={href}
      />
    </ButtonWrapper>
    <Tooltip text="Apply" />
  </LinkButton>
);

const CopyToClipboardButton = ({ text }) => {
  const [processingTooltipOpen, setProcessingTooltipOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [processedMsg, setProcessedMsg] = useState<TProcessedMsg>(null);

  const copyText = async (text?: string) => {
    try {
      setProcessing(true);
      setProcessingTooltipOpen(true);
      navigator.clipboard.writeText(text);
      setProcessedMsg('Copied to clipboard');
      setTimeout(() => {
        setProcessingTooltipOpen(false);
        setProcessing(false);
      }, 100);
    } catch (e) {
      console.error('Failed to copy link to clipboard', e);
      setProcessing(false);
      setProcessingTooltipOpen(false);
      setProcessedMsg('Something went wrong');
    }
  };

  return (
    <LinkButton>
      <ButtonWrapper>
        <IconButton
          iconType="Email"
          size="2.5rem"
          onClick={() => {
            copyText(text);
          }}
        />
      </ButtonWrapper>
      <Tooltip text="Copy to clipboard" />
      <ProcessingTooltip
        isTooltipVisible={processingTooltipOpen}
        processing={processing}
        processedMsg={processedMsg}
      />
    </LinkButton>
  );
};

const MerchantLinksList = ({ refreshPage }: TMerchantLinksList) => {
  const anytimeUrlBase = process.env.REACT_APP_ANYTIME_URL;

  return (
    <>
      <LinksContainer>
        <LinkWrapper>
          <Link>
            <LinkHeading>Resend password reset link for Staff</LinkHeading>
            <LinkButtons>
              <CopyToClipboardButton
                text={`${window.location.origin}/reset-password`}
              />
            </LinkButtons>
          </Link>
          <Link>
            <LinkHeading>Resend password reset link for Students</LinkHeading>
            <LinkButtons>
              <CopyToClipboardButton
                text={`${anytimeUrlBase}/reset-password?studyLoan=true`}
              />
            </LinkButtons>
          </Link>
        </LinkWrapper>
      </LinksContainer>
    </>
  );
};

export { MerchantLinksList };
